import { ensureAccessToken, getRefreshToken } from "./auth";

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

const isAuthFailure = (status) => status === 401 || status === 403;

const withAuthHeader = (options, token) => {
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };

  return {
    ...options,
    headers,
  };
};

export const fetchWithAuthRetry = async (url, options = {}) => {
  const token = await ensureAccessToken();
  let response = await fetch(url, withAuthHeader(options, token));

  if (isAuthFailure(response.status)) {
    const refreshedToken = await getRefreshToken();
    response = await fetch(url, withAuthHeader(options, refreshedToken));
  }

  return response;
};
